import { render, staticRenderFns } from "./todolist.vue?vue&type=template&id=c0e7141e&scoped=true&"
import script from "./todolist.vue?vue&type=script&lang=js&"
export * from "./todolist.vue?vue&type=script&lang=js&"
import style0 from "./todolist.vue?vue&type=style&index=0&id=c0e7141e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0e7141e",
  null
  
)

export default component.exports